import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import { en } from './translations/en-US.jsx';
import { nl } from './translations/nl-NL.jsx';

// No local/session caching of language: this initializes to a hardcoded
// default and the user's actual "preferred-language" preference is fetched
// from the user-preferences API and applied via i18n.changeLanguage() by
// ThemePreferencesLoader once authenticated.
i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: {
        translation: en,
      },
      nl: {
        translation: nl,
      },
    },
    lng: 'nl', // Default until ThemePreferencesLoader applies the API preference
    fallbackLng: 'en', // Fallback language
    keySeparator: '.', // Use dots for nested keys (e.g., 'common.dashboard')
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
